<script setup lang="ts">
import { computed, useTemplateRef } from 'vue';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskLayout> in <template>
import KioskLayout from '@/app/layouts/kiosk/KioskLayout.vue';
// biome-ignore lint/style/useImportType: component is rendered in <template>
import GoPhotoScanPanel from './gophoto-scan/GoPhotoScanPanel.vue';
import { useGoPhotoScanFlow } from './gophoto-scan/useGoPhotoScanFlow';
import { useTranslateOr } from './gophoto-upload/useTranslateOr';

const { t, translateOr } = useTranslateOr();
const panelRef =
  useTemplateRef<InstanceType<typeof GoPhotoScanPanel>>('panelRef');

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const title = computed(() =>
  translateOr('GoPhotoScan.title', 'Scan Your PhotoPass')
);
// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const subtitle = computed(() =>
  translateOr(
    'GoPhotoScan.subtitle',
    'Hold your PhotoPass QR code up to the scanner'
  )
);
// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const loadingLabel = computed(() =>
  translateOr('Common.loading', 'Processing...')
);

const {
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  displayCode,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  error,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  handleInput,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  handleKeydown,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  isLoading,
  publicApi,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  rawInput,
} = useGoPhotoScanFlow({
  focusInput: () => panelRef.value?.focusInput(),
  startFocusManagement: () => panelRef.value?.startFocusManagement(),
  stopFocusManagement: () => panelRef.value?.stopFocusManagement(),
  translate: (key: string, fallback: string) => t(key) || fallback,
});

defineExpose(publicApi);
</script>

<template>
  <KioskLayout :is-centered="true">
    <GoPhotoScanPanel
      ref="panelRef"
      :display-code="displayCode"
      :error="error"
      :is-loading="isLoading"
      :loading-label="loadingLabel"
      :raw-input="rawInput"
      :subtitle="subtitle"
      :title="title"
      @input="handleInput"
      @keydown="handleKeydown"
    />
  </KioskLayout>
</template>
